// extracted by mini-css-extract-plugin
export default {"nav":"NavigationPanel_nav__bFJsf","item":"NavigationPanel_item__xwl-M"};